import { render } from "./CollectionItem.vue?vue&type=template&id=46e59b05&scoped=true"
import script from "./CollectionItem.vue?vue&type=script&lang=js"
export * from "./CollectionItem.vue?vue&type=script&lang=js"

import "./CollectionItem.vue?vue&type=style&index=0&id=46e59b05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e59b05"]])

export default __exports__